import TemplateView from '../../../../TemplateView'
import Tooltip from './Tooltip'
import {DateFormat} from '../../../../date_format'
import UserTime from '../../../../user_time'
import messageResource from '../../../../messageResource'
import LeaveTypeStore from '../../../../store/LeaveTypeStore'
import _ from 'underscore'

export default class DayRow extends TemplateView
{
    constructor({
        dayModel = null,
    } = {})
    {
        super()

        this.params = {
            dayModel,
        }
    }

templateHtml() {
    return "<tr class='dayRow'>" +
           "  <td class='nameColumn'>" +
           "    <table cellspacing='0' cellpadding='0'>" +
           "      <tr>" +
           "        <td class='dateColumn'>" +
           "          <div class='subContainer'>" +
           "            <span><%-date%></span>" +
           "            <div class='separator'/>" +
           "            <span class='nonWorkingLabel'/>" +
           "          </div>" +
           "        </td>" +
           "        <td class='approvedStatusColumn'>" +
           "          <div class='subContainer'>" +
           "            <span class='autoApprovedLabel'><%=autoApprovedLabel%></span>" +
           "            <span class='approvedLabel'><%=approvedLabel%></span>" +
           "            <span class='notReadyLabel'><%=notReadyLabel%></span>" +
           "            <span class='readyLabel'><%=readyLabel%></span>" +
           "            <span class='rejectedLabel'><%=rejectedLabel%></span>" +
           "            <span class='lockedLabel for-print-only'>Locked</span>" +
           "          </div>" +
           "        </td>" +
           "      </tr>" +
           "    </table>" +
           "  </td>" +
           "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" +
           "  <td class='detailsColumn'>" +
           "    <table cellspacing='0' cellpadding='0'>" +
           "      <tr>" +
           "        <td class='workingTimeColumn'>" +
           "          <div class='subContainer'>" +
           "            <span><%=workingTimeLabel%>:</span>" +
           "            <span class='workingTime'><%-workingTime%></span>" +
           "          </div>" +
           "        </td>" +
           "        <td class='overtimeColumn'>" +
           "          <div class='subContainer'>" +
           "            <span class='overtimeLabel'><%=overtimeLabel%>:</span>" +
           "            <span class='overtime'><%-overtime%></span>" +
           "          </div>" +
           "        </td>" +
           "        <td class='leaveTimeColumn'>" +
           "          <div class='subContainer'>" +
           "            <span class='leaveTimeName'><%-leaveTimeName%>:</span>" +
           "            <span class='leaveTime'><%-leaveTime%></span>" +
           "          </div>" +
           "        </td>" +
           "      </tr>" +
           "    </table>" +
           "  </td>" +
           "</tr>"
}

    beforeRender()
    {
        this.leaveTime = this.params.dayModel.leave && this.params.dayModel.leave.leaveTime || 0;
        if (this.params.dayModel.overtime)
            this.overtime = _.isNumber(this.params.dayModel.overtime.reported) ? this.params.dayModel.overtime.reported : this.params.dayModel.overtime.auto;
        else
            this.overtime = 0;
        this.workingTime = this.params.dayModel.totalWorkingTime;
        this.totalTime = this.leaveTime + this.workingTime;
    }

    afterRender()
    {
        const nonWorking = this.params.dayModel.workdayDuration === 0
        if (nonWorking) {
            const corporateDayName = this.params.dayModel.corporateDayName ? this.params.dayModel.corporateDayName + ' ' : ''
            this.find('.nonWorkingLabel').text(corporateDayName + messageResource.getMessage('view_tt.details_table.day_row.nonworking'))
        }
        this.find('.dateColumn .separator').toggle(nonWorking && !!this.params.dayModel.corporateDayName)

        this.$el.toggleClass("autoApproved", this.params.dayModel.approvalStatus === EffectiveWeekApprovalStatus.AUTO_APPROVED);
        this.$el.toggleClass("approved", this.params.dayModel.approvalStatus === EffectiveWeekApprovalStatus.APPROVED);
        this.$el.toggleClass("notReady", this.params.dayModel.approvalStatus === EffectiveWeekApprovalStatus.NOT_READY);
        this.$el.toggleClass("ready", this.params.dayModel.approvalStatus === EffectiveWeekApprovalStatus.READY);
        this.$el.toggleClass("rejected", this.params.dayModel.approvalStatus === EffectiveWeekApprovalStatus.REJECTED);
        this.$el.toggleClass("locked", this.params.dayModel.locked);
        this.$el.toggleClass("nonWorking", nonWorking);
        this.$el.toggleClass("noOvertime", !_.isObject(this.params.dayModel.overtime));
        this.$el.toggleClass("noLeaves", !_.isObject(this.params.dayModel.leave));
        this.$el.toggleClass("leaveTimeZero", this.leaveTime === 0);
        this.$el.toggleClass("workingTimeZero", this.workingTime === 0);
        this.$el.toggleClass("totalTimeZero", (this.workingTime + this.leaveTime) === 0);
        this.$el.toggleClass("overtimePositive", this.overtime > 0);
        this.$el.toggleClass("overtimeNegative", this.overtime < 0);
        this.$el.toggleClass("overtimeZero", this.overtime === 0);

        this.tooltip = Tooltip.getInstance();
        this.tooltip.subscribeToMouseEvents(this.$el, this.bind(this._beforeTooltipShow));

        this.$el.click(this.bind(this._onClick));
    }

    templateModel()
    {
        return {
            date: DayRow.tableDateFormat.formatDate(this.params.dayModel.date),
            name: this.params.dayModel.name,
            total: UserTime.formatTimeWithDigitSeparator(this.totalTime),
            workingTime: this.workingTime ? UserTime.formatTimeWithDigitSeparator(this.workingTime) : "--",
            leaveTime: this.leaveTime ? UserTime.formatTimeWithDigitSeparator(this.leaveTime) : "--",
            overtime: this.overtime ? UserTime.formatTimeWithDigitSeparator(this.overtime) : "--",
            leaveTimeName: this.leaveTime ? LeaveTypeStore.getLeaveType(this.params.dayModel.leave.leaveTypeId).name :
                           messageResource.getMessage("view_tt.details_table.day_row.leave_time")
        }
    }

    messageKeys()
    {
        return {
            autoApprovedLabel: "view_tt.details_table.day_row.auto_approved",
            approvedLabel: "view_tt.details_table.day_row.approved",
            notReadyLabel: "view_tt.details_table.day_row.not_ready",
            readyLabel: "view_tt.details_table.day_row.ready",
            rejectedLabel: "view_tt.details_table.day_row.rejected",
            workingTimeLabel: "view_tt.details_table.day_row.working_time",
            overtimeLabel: "overtime.overtime"
        };
    }

    _onClick()
    {
        window.location.href = ViewTTPageUtils.createEnterTTURL(this.params.dayModel.date);
    }

    _beforeTooltipShow()
    {
        this.tooltip.updateDate(this.params.dayModel.date);
    }
}

DayRow.tableDateFormat = new DateFormat("MMM dd, EEE");


// WEBPACK FOOTER //
// ./web/js/user/viewtt/detailsTable/dayRow/DayRow.js